import { LinkI, ModularBlockLinkI } from 'interfaces/content-stack/contentStack.types';
import { ModularBlockTypes } from 'interfaces/content-stack/modular-blocks/modularBlocks.types';

import { isExternalUrl } from 'utils/linkResolver';

export function getBlockType(data: any) {
  if (!data) {
    return null;
  }

  return Object.keys(data).find((k) => !!data[k] && k !== '__typename') as ModularBlockTypes | undefined;
}

export const getModularBlockLink = (modularBlockLink?: ModularBlockLinkI[] | LinkI[]): string | undefined => {
  const breadcrumb = modularBlockLink?.[0]?.breadcrumb;
  const mainUrl = modularBlockLink?.[0]?.linkUrl?.href ?? modularBlockLink?.[0]?.url ?? '';
  const urlPrefix = breadcrumb && breadcrumb.length > 0 ? breadcrumb.map((item) => item.url).join('') : '';

  if (isExternalUrl(mainUrl)) {
    return mainUrl;
  }

  const fullUrl = urlPrefix + mainUrl;

  // This regex should match the various tastyfx domains - i.e. tastyfx.com or tastyfx.caxy.com, with or without www.
  const localRe = /(www\.)?tastyfx\.(caxy\.)?com/g;

  if (fullUrl.match(localRe)) {
    // malformed local url - correct and return
    return fullUrl
      .replaceAll(localRe, '')
      .replace(/^https?:\/\//, '')
      .replaceAll('//', '/');
  }

  return fullUrl.replaceAll('//', '/');
};

export const getModularBlockLinkData = (
  modularBlockLink?: ModularBlockLinkI[] | LinkI[]
): {
  link: string;
  target: string;
  openInNewWindow: boolean;
} => {
  if (modularBlockLink) {
    return {
      link: getModularBlockLink(modularBlockLink) ?? '',
      target: modularBlockLink[0]?.openInNewWindow ? '_blank' : '_self',
      openInNewWindow: !!modularBlockLink[0]?.openInNewWindow,
    };
  }

  return {
    link: '',
    target: '_self',
    openInNewWindow: false,
  };
};
